const AlertIcon: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-alert-circle"
      {...props}>
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );
};

const CheckedSquare: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-check-square"
      {...props}>
      <polyline points="9 11 12 14 22 4"></polyline>
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
    </svg>
  );
};
const UnCheckedSquare: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100.000000pt"
      height="100.000000pt"
      viewBox="0 0 100.000000 100.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}>
      <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path
          d="M156 978 c-56 -15 -120 -82 -134 -140 -16 -64 -16 -612 0 -676 15
-62 78 -125 140 -140 64 -16 612 -16 676 0 62 15 125 78 140 140 16 64 16 612
0 676 -15 62 -78 125 -140 140 -59 15 -626 14 -682 0z m642 -118 c33 -15 47
-29 62 -62 18 -39 20 -67 20 -298 0 -231 -2 -259 -20 -298 -15 -33 -29 -47
-62 -62 -39 -18 -67 -20 -298 -20 -231 0 -259 2 -298 20 -33 15 -47 29 -62 62
-18 39 -20 67 -20 298 0 231 2 259 20 298 15 33 29 47 62 62 39 18 67 20 298
20 231 0 259 -2 298 -20z"
        />
      </g>
    </svg>
  );
};
const UnCheckedCircle: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-circle"
      {...props}>
      <circle cx="12" cy="12" r="10"></circle>
    </svg>
  );
};
const CheckedCircle: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <path d="M160 256C160 202.1 202.1 160 256 160C309 160 352 202.1 352 256C352 309 309 352 256 352C202.1 352 160 309 160 256zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" />
    </svg>
  );
};
const CloseIcon: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-x"
      {...props}>
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
};
const MoveDownIcon: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-arrow-down-circle"
      {...props}>
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="8 12 12 16 16 12"></polyline>
      <line x1="12" y1="8" x2="12" y2="16"></line>
    </svg>
  );
};

export { AlertIcon, CheckedSquare, UnCheckedCircle, CheckedCircle, UnCheckedSquare, MoveDownIcon, CloseIcon };
